<template>
  <div class="field-of-fields">
    <!-- <form class="profile-form"> -->
    <h3 style="margin-bottom: 0;">Edit Professional Information</h3>
    <hr style="margin-bottom: 0px;" />
    <FormGroupColumnLayout
      :submitClicked="submitClicked"
      :modelData="professionalInfo"
      :listFields="$store.getters.professionalInfoFields"
      :itemPerColumns="[10, 14]"
    />
    <hr />
    <button
      class="mylisting-button dark-button"
      style="display: block; margin-left: auto;"
      @click.prevent="save()"
    >
      Save
    </button>
    <!-- </form> -->
  </div>
</template>

<script>
import axios from "axios";
import FormGroupColumnLayout from "../../common/FormGroupColumnLayout";

export default {
  components: {
    FormGroupColumnLayout
  },
  props: ["user"],
  data() {
    return {
      submitClicked: false,
      professionalInfo: this.extractSelectedFields(
        this.user,
        this.$store.getters.professionalInfoFields
      )
    };
  },
  methods: {
    save() {
      this.submitClicked = true;
      if (
        this.hasInvalidField(
          this.professionalInfo,
          this.$store.getters.professionalInfoFields
        )
      ) {
        this.showErrorDialog(this.$store.getters.invalidInputError);
      } else {
        this.updateProfessionalInfo();
      }
    },
    updateProfessionalInfo() {
      axios
        .patch(
          "/api/people/".concat(this.user.id.toString()).concat("/"),
          this.professionalInfo
        )
        .then(res => {
          this.$emit("infoSaved");
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/candidates/profile/ProfessionalInfoForm.vue